import { render, staticRenderFns } from "./StepListaPrestadores.vue?vue&type=template&id=1a5e89a9"
import script from "./StepListaPrestadores.vue?vue&type=script&lang=js"
export * from "./StepListaPrestadores.vue?vue&type=script&lang=js"
import style0 from "./StepListaPrestadores.vue?vue&type=style&index=0&id=1a5e89a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports